<template>
  <div v-if="comment">
    <v-card>
      <v-card-title>
        <v-layout row>
          <v-icon size=48>person_outline</v-icon>
          <v-flex class="subheading text-truncate ml-3 pt-2">
            <br>
            <span slot="activator" class="caption">
              {{ comment.updated_at | formatDateAgo }} on {{ comment.updated_at | formatDateLong}}
            </span>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-card-text class="pt-0">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="pl-2 comment trix-content" @click="commentMessageClick" v-html="comment.message" v-if="comment.is_html"></div>
            <div class="pl-2 comment trix-content" v-else>{{comment.message}}</div>
          </v-flex>

          <v-flex xs12 sm3 lg2 v-for="(att, idx) in (comment.attachments)" :key="idx" class="attachment ma-1 pa-1 text-xs-center text-truncate text-nowrap caption">
            <a :href="auth.decorate_path_with_access_params(att.download_url)" target="attachments">
              <v-img
                v-if="att.content_type.includes('image')"
                class="hidden-xs-only mb-2"
                height=100
                contain
                :src="auth.decorate_path_with_access_params(att.preview_url)"
              />
              <v-icon size=120 class="hidden-xs-only" v-else>attachment</v-icon>
              <br>
              <span class="pt-2">
                {{att.filename}}
                <br>
                {{att.filesize | toFileSize}}
              </span>
            </a>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="pt-3">
          <v-flex xs3 sm3 lg1 class="caption text-uppercase text-xs-right pr-2 pt-1">Status</v-flex>
          <v-flex xs3 sm3 lg2>
            <v-chip :color="status.color" disabled small outline class="ma-0 pa-0">
              {{status.name }}
            </v-chip>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import authentication from '@/utilities/authentication'

  export default {
    name: 'share-comment',

    props: ['comment', 'ticket', 'status'],

    components: {
    },

    data () {
      return {
        auth: authentication
      }
    },

    computed: {
    },

    mounted () {
    },

    methods: {
      commentMessageClick (e) {
        if (e.target.matches('img')) {
          if (e.target.classList.contains('expanded')) {
            e.target.classList.remove('expanded')
          } else {
            e.target.classList.add('expanded')
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .attachment {
    border: 1px solid #d3d3d3;
  }

  .comment {
    white-space: pre-wrap;
  }
</style>





// WEBPACK FOOTER //
// src/components/share/_comment.vue